
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./basics-0-introduction.json") })
        }
      }, "path---basics-0-introduction");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=path---basics-0-introduction!./.cache/json/basics-0-introduction.json
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=path---basics-0-introduction!./.cache/json/basics-0-introduction.json
// module chunks = 154